import React, { Component } from 'react'

var ES6Promise = require('es6-promise')
ES6Promise.polyfill()

export class Message extends Component {
  render () {
    return (
      <div className='content content-user-preferences error grid-content-full'>
        <div>{this.props.children}</div>
        <div className='inner-container'>
          <a className='pure-button primary-action margin-left-0' href={`/#/${this.props.url}`} target='_self'>
            {this.props.buttonText}
          </a>
        </div>
      </div>
    )
  }
}

export default Message
